export default __webpack_public_path__ + "guide--raster-cyclone-debbie-960-fd8a6b03938a0c45c3da20329ebcf55d.webp";